import type { Subscriber } from 'rxjs';

/**
 * This wraps the RXJS Subscriber object so that odin-components consumers can't close the subscriber stream from their
 * project and break the data retriever functionality.
 *
 * @deprecated Push-based data retrieval is legacy. Use RTK Query (`builder.query` / `builder.infiniteQuery`) instead.
 * Existing usage stays until each consuming component is migrated. See `docs/adr/ADR-017-data-fetching-strategy.md`.
 */
export class OdinDataSender<T> {
  private subscriber: Subscriber<T>;

  constructor(subscriber: Subscriber<T>) {
    this.subscriber = subscriber;
  }

  /**
   * Sends data to the calling component.
   * @param {T} value - The data the calling component will use.
   */
  public sendData(value?: T) {
    this.subscriber.next(value);
  }

  /**
   * Sends data to the calling component and closes the subscriber. This is used when sending data doesn't complete
   * until the subscriber is closed (like when using forkJoin).
   * @param {T} value - The data to send to the calling component.
   */
  public sendFinalData(value?: T) {
    this.subscriber.next(value);
    this.subscriber.complete();
  }
}
